//  将带 - 的字符串转换成驼峰命名
export const transformHump = str => str && str.replace(/-(\w)/g, ($0, $1) => $1.toUpperCase()) || str